import React from "react"
import { InstagramPosts } from "./InstagramPosts"

export const Container = ({ nodes }) => {
  return (
    <div className="ig-container">
      <InstagramPosts nodes={nodes} />
    </div>
  )
}